import React, { useEffect, useState } from "react";
import { getIn, setIn } from "formik";
import { autocompletePartners } from "../../services/partner.service.ts";
import { toCamelCase } from "../../hooks/toCameCase.tsx";
import { PartnerAutocomplete } from "../../models/PartnerAutocomplete.ts";

const PartnersAutocomplete = ({ label = "Chilito reemplazo", ...props }) => {
  const [value, setValue] = useState<PartnerAutocomplete | string>("");
  const [options, setOptions] = useState<PartnerAutocomplete[]>([]);
  const [showOptions, setShowOptions] = useState(false);
  const [loading, setLoading] = useState(false);

  const error = Boolean(
    getIn(props.formik.touched, props.field) &&
      getIn(props.formik.errors, props.field)
  );

  let timeoutId: any;

  const handleChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
    const val = event.target.value;
    setValue(val);
    setLoading(true);

    if (timeoutId) clearTimeout(timeoutId);

    timeoutId = setTimeout(async () => {
      try {
        const data = await autocompletePartners(val);
        setOptions(data);
      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false);
      }
    }, 500);
  };

  const handleSelect = (data: PartnerAutocomplete) => {
    setValue(data);
    setShowOptions(false);

    const updatedValues = setIn(props.formik.values, props.field, data?.id);
    props.formik.setValues(updatedValues);
  };

  const clearSelection = () => {
    setValue("");
    setOptions([]);
    setShowOptions(false);
    props.formik.setFieldValue(props.field, 0);
  };

  useEffect(() => {
    const fetchInitial = async () => {
      const data = await autocompletePartners("");
      setOptions(data);
    };
    fetchInitial();
  }, []);

  const displayValue =
    typeof value === "string"
      ? value
      : toCamelCase(
          `${value?.person?.firstName ?? ""} ${value?.person?.lastName ?? ""} ${
            value?.person?.secondLastName ?? ""
          }`
        );

  return (
    <div className="row mb-4 fs-13px col-md-12">
      <label
        className={`form-label col-form-label col-md-${props.smLabel} text-end`}
        style={{ color: error ? "red" : "inherit" }}
      >
        {label}&nbsp;
        <span style={{ color: error ? "red" : "inherit" }}>*</span>
      </label>

      <div
        className={`col-md-${props.sm}`}
        style={{ position: "relative", zIndex: 10 }}
      >
        <div style={{ position: "relative" }}>
          {/* Icono de carga o búsqueda */}
          <div
            style={{
              position: "absolute",
              left: "10px",
              top: 0,
              bottom: 0,
              display: "flex",
              alignItems: "center",
              zIndex: 1,
              color: "#999",
            }}
          >
            {loading ? (
              <i className="fa fa-spinner fa-spin" />
            ) : (
              <i className="fa fa-search opacity-5" />
            )}
          </div>

          {/* Botón limpiar */}
          {value && value !== "" && (
            <button
              type="button"
              onClick={clearSelection}
              style={{
                position: "absolute",
                right: "10px",
                top: 0,
                bottom: 0,
                display: "flex",
                alignItems: "center",
                background: "none",
                border: "none",
                color: "#999",
                cursor: "pointer",
                zIndex: 1,
              }}
            >
              <i className="fa fa-times" />
            </button>
          )}

          {/* Input */}
          <input
            type="text"
            className={`form-control ps-4 pe-4 ${error ? "is-invalid" : ""}`}
            placeholder="Busca a un chilito"
            id="product-key-input"
            autoComplete="off"
            onChange={handleChange}
            onFocus={() => setShowOptions(true)}
            onBlur={() => setShowOptions(false)}
            value={displayValue}
          />
        </div>

        {/* Opciones */}
        {showOptions && (
          <ul
            className="list-group mt-2"
            style={{
              position: "absolute",
              zIndex: 1000,
              backgroundColor: "white",
              width: "100%",
              maxHeight: "200px",
              overflowY: "auto",
              border: "1px solid #ccc",
              top: "calc(100% + -8px)",
            }}
          >
            {options.length > 0 ? (
              options.map((data, index) => (
                <li
                  key={index}
                  className="list-group-item list-group-item-action"
                  onMouseDown={() => handleSelect(data)}
                >
                  {toCamelCase(
                    `${data.person.firstName} ${data.person.lastName} ${data.person.secondLastName}`
                  )}
                </li>
              ))
            ) : (
              <li className="list-group-item list-group-item-action">
                No hay resultados
              </li>
            )}
          </ul>
        )}
      </div>
    </div>
  );
};

export default PartnersAutocomplete;
